export class FiltroListaDistribuzioneDTO {
  nome: string;
  descrizione: string;
  nomeSettore: string[];
}
